module.exports = __webpack_public_path__ + "static/media/magicad-logo.376bb9b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/magicad-logo.png
// module id = 1515
// module chunks = 0